const Agronomy = {

    // FIELDS
    "customer": "Customer",
    "project": "Project",
    "fname": "First Name",
    "lname": "Last Name",
    "gender": "Gender",
    "dob": "Date of Birth",
    "status": "Status",
    "mobile": "Mobile Number",
    "email": "Email",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "profile": "Profile Photo",
    "district": "District",
    "address": "Address",

    "search": "Search",

    // PAGE HEADER
    "agronomy": "Agronomist",

    // ERROR
    "error_customer": "Select Customer",
    "error_project": "Select Project",
    "error_min_project": "Select at least one project",
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_gender": "Select Gender",
    "error_dob": "Choose Date of Birth",
    "error_status": "Select Status",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_email": "Enter Email",
    "error_password": "Enter Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_pass_match": "Confirm Password doesn't match",
    "error_profile": "Choose Profile Photo",
    "error_district": "Select District",
    "error_address": "Enter Address",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_username": 'USERNAME',
    "table_email": 'EMAIL',
    "table_mobile": 'MOBILE',
    "table_district": 'DISTRICT',
    "table_status": "STATUS",

}

export default Agronomy;